"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApiKeyName = void 0;
const buildApiKeyName = (programStage) => `ApiKey-${programStage}`;
exports.buildApiKeyName = buildApiKeyName;
//# sourceMappingURL=programSettingDb.js.map